import {
  ComplexFmfFareFamily,
  ComplexFmfFareFamilyAirOffersInner,
  ComplexFmfFareFamilyAirOffersInnerComplexBoundsInnerComplexFlightsInner,
  ComplexItinerary,
  Type5ItinerariesInner,
} from 'src/sdk-search';
import { ComplexFlightAvailabilityContComponent } from '../container/complex-flight-availability-cont.component';
import { InitialBase } from './initial-base.class';
import { AutoInject, RakuFlow } from './raku-flow';
import { ComplexFlightAvailabilityRequestService } from '../service/request.service';
import { ComplexFlightAvailabilityStoreService } from '../service/store.service';
import { fetchComplexRequestData } from './data';
import { SearchFlightHistoryStoreService, DeliveryInformationStoreService } from '@common/services';
import { PageType, RetryableError } from '@lib/interfaces';
import { deepCopy } from '@common/helper';
import { UpgradeavailabilityResponse } from '@common/interfaces/shopping/upgrade-availability/upgradeavailabilityResponses';
import { UpgradeAvailabilityRequest } from '@common/interfaces/upgradeavailablityRequest/upgradeavailablityRequest';
import { AirOfferUpgradeInfo, BoundUpgradeInfo, CabinClassUpgradeInfo, FlightUpgradeInfo } from '@common/interfaces';
import { vacantInformationForFlight } from '@common/interfaces/shopping/upgrade-availability/upgradeavailabilityResponsesForFlight';
import { ComplexFlightAvailabilityUntilService } from '../service/utils.service';

/**
 * 以下、[画面表示後の処理]とする。
 */
export class InitialProcessAfter extends InitialBase {
  override flow?: RakuFlow<InitialBase, ComplexFlightAvailabilityContComponent>;
  private _componentPtr = this.flow?.root;

  @AutoInject()
  private _requestService?: ComplexFlightAvailabilityRequestService;

  @AutoInject()
  private _storeService?: ComplexFlightAvailabilityStoreService;

  @AutoInject()
  private _searchFlightHistoryStoreService?: SearchFlightHistoryStoreService;

  @AutoInject()
  private _untilService?: ComplexFlightAvailabilityUntilService;

  @AutoInject()
  private _deliveryInformationStoreService?: DeliveryInformationStoreService;

  constructor() {
    super();
  }

  // contextをapply
  override bindFlow(
    flow: RakuFlow<InitialBase, ComplexFlightAvailabilityContComponent>
  ): RakuFlow<InitialBase, ComplexFlightAvailabilityContComponent> {
    this.flow = flow;
    this._componentPtr = this.flow.root;
    return flow;
  }

  // メイン
  override async handle(): Promise<void> {
    // リクエスト要検索条件
    const _complexRequest = await fetchComplexRequestData(this._storeService);

    // アップグレード情報リスト取得
    let concernedUpgradeInfoList = await this._storeService?.fetchUpgradeInfoList();

    const isUserLogin = (await this._storeService?.fetchIsUserLogin()) ?? false;
    // loginしない場合は、終了
    if (!isUserLogin) return;

    // プラン確認画面にて保持されたプラン作成失敗判定が存在する場合、エラーメッセージID＝”E1059”にて継続可能なエラー情報を指定し、当画面でエラーメッセージを表示する。
    if (this._deliveryInformationStoreService?.deliveryInformationData.planReviewInformation?.isPlanDuplicationFailed) {
      const errorInfo: RetryableError = {
        errorMsgId: 'E1059',
      };
      this.setRetryableErrorInfo(PageType.PAGE, errorInfo);
    }

    // ユーザ共通.ログインステータス≠未ログインの場合、以下を実施する。

    // フライト検索画面(R01-P010)の[履歴・お気に入り情報取得処理]を行う。
    this._searchFlightHistoryStoreService?.requestHistoryFavoriteGet(false);
    await this._untilService?.isCheckFavorite();
  }
}
